<!--
 * @FilePath: organize.vue
 * @Author: chenwei
 * @Date: 2022-07-31 10:02:26
 * @LastEditors: chenwei
 * @LastEditTime: 2022-08-16 09:01:23
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
  <div class="mian-article">
      <Header/>
      <div class="width1200 center">
        <div class="box">
          <h1 style="transform: translateY(-40px)">{{ $t('about.OrganizationalFramework') }}</h1>
          <div class="center">
            <img v-if="!isEnglish" src="@/assets/image/aboutUs/organize.png" alt="">
            <img v-if="isEnglish" src="@/assets/image/aboutUs/orgen.png" alt="">
          </div>
        </div>
      </div>
      <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
export default {
    components:{
        Header,
        Footer
    },
    data(){
        return {
          isEnglish:false
        }
    },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  }
}
</script>

<style scoped lang="scss">
    .mian-article{
        @include home_bg_t2_color();
        h1{
            text-align: center;
        }
        .width1200{
           width: 100%;
          background-image: url("../../assets/image/aboutUs/bg.png");
          background-repeat: no-repeat;
          background-size: cover;
          .box{
            width: 1400px;
            background-color: #FFFFFF;
            margin: 0 auto;
            padding:  88px 90px;
            box-sizing: border-box;
          }
            @include co_white_to_black();
            
            p{
                margin: 24px 0;
                text-indent: 2em;
            }
        }
    }
</style>